<script setup lang="ts">
import { computed } from 'vue';
import { SunIcon, MoonIcon } from '@heroicons/vue/24/outline';
import { useTheme } from '../composables/useTheme';

const { theme, toggleTheme } = useTheme();
const isDark = computed(() => theme.value === 'dark');
</script>

<template>
  <button
    @click="toggleTheme"
    class="p-2 rounded-lg text-secondary-500 hover:bg-secondary-100 dark:hover:bg-secondary-700 transition-colors"
    :title="isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'"
  >
    <SunIcon v-if="isDark" class="h-6 w-6" />
    <MoonIcon v-else class="h-6 w-6" />
  </button>
</template>